var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('b-alert',{staticClass:"alertTime",attrs:{"show":"","variant":"danger"}},[_c('b-icon',{attrs:{"icon":"exclamation-circle-fill","variant":"danger"}}),_vm._v(" "+_vm._s(_vm.message)+" "),_c('b-icon',{attrs:{"icon":"exclamation-circle-fill","variant":"danger"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }